<script>
import ContentTree from '@/components/lessons/ContentTree.vue';
export default { name: 'contents', components: { ContentTree } };
</script>
<template>
  <main class="contents-page" dir="rtl">
    <header><h1>محتوى الحصص</h1><p>تصفح الفروع والوحدات، ثم افتح الدرس الذي تريد مشاهدته.</p></header>
    <ContentTree branch-navigation />
  </main>
</template>
<style scoped>
.contents-page { width: 100%; max-width: 1160px; min-width: 0; margin: auto; padding: 1.5rem 1rem 6rem; overflow-wrap: anywhere; }
header { margin-bottom: 1.5rem; }
h1 { font-size: clamp(1.5rem, 4vw, 2.2rem); }
/* Keep card gutters above the legacy full-width mobile contents rule. */
@media (max-width: 768px) { .contents-page { padding: 1.25rem .75rem 6rem !important; } }
</style>
